import { useActiveMember } from 'hooks';
import useSlackClient from './useSlackClient';

export default function useSlackBetaPremiumTrialAccess() {
  const client = useSlackClient();
  const member = useActiveMember();

  function requestAccess() {
    const metaData = `${member.organizationId}`;

    const requestBody = {
      text: metaData,
    };

    return client.post('T025A2121/B05URD5039N/m9unwhlVB7BLCn1xgiU48GdR', JSON.stringify(requestBody));
  }

  return requestAccess;
}